import { Swiper, Navigation } from 'swiper';

Swiper.use([Navigation]);

export default (node) => {
  const sliderEl = node.querySelector('[data-mega-slider]');

  if (!sliderEl) return;

  const prevButton = node.querySelector('[data-mega-slider-prev]');
  const nextButton = node.querySelector('[data-mega-slider-next]');

  const swiper = new Swiper(sliderEl, {
    slidesPerView: 1,
    spaceBetween: 8,
    slidesPerGroup: 1,
    // Locks the slider and hides the arrows when every slide already fits
    watchOverflow: true,
    ...(prevButton && nextButton
      ? {
          navigation: {
            prevEl: prevButton,
            nextEl: nextButton,
            lockClass: 'hidden',
            disabledClass: 'opacity-40',
          },
        }
      : {}),
    breakpoints: {
      1000: {
        slidesPerView: 2,
      },
      1800: {
        slidesPerView: 3,
      },
    },
  });

  /**
   * The mega menu is display:none until its parent nav item is hovered, so
   * Swiper measures zero-width slides on mount. Re-measure on every open.
   */
  const megaMenu = node.closest('[data-mega-menu-end]');

  if (megaMenu) {
    const observer = new MutationObserver(() => {
      if (!megaMenu.classList.contains('hidden')) {
        swiper.update();
      }
    });

    observer.observe(megaMenu, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
};
